const initialState = {
  resultsTaxesList: [],
  resultsTax: {},
  resultsTaxAdd: {},
  resultsTaxUpdate: {},
  resultsTaxEdit: {},
  resultsTaxDelete: {},
  resultsTaxProductAdd: {},
  resultsTaxProducts: [],
  resultsTaxProductsDelete: {},
  resultsProductTaxesList: [],
  loading: false,
};

const reducer = (state = initialState, action) => {
  const newState = { ...state };

  switch (action.type) {
    // Actions that start loading
    case "GET_LIST_TAX":
    case "GET_LIST_PRODUCT_TAX":
    case "GET_TAX":
    case "ADD_TAX":
    case "EDIT_TAX":
    case "UPDATE_TAX":
    case "DELETE_TAX":
    case "ADD_TAX_PRODUCT":
    case "GET_TAX_PRODUCTS":
    case "DELETE_TAX_PRODUCTS":
    case "GET_PRODUCT_TAX":
      newState.loading = true;
      break;

    // Actions that stop loading & handle data
    case "LIST_TAX_RESPONSE_GET":
      newState.resultsTaxesList = action.value;
      newState.loading = false;
      break;
    case "LIST_PRODUCT_TAX_RESPONSE_GET":
      newState.resultsProductTaxesList = action.value;
      newState.loading = false;
      break;
    case "TAX_RESPONSE_GET":
      newState.resultsTax = action.value;
      newState.loading = false;
      break;
    case "TAX_RESPONSE_ADD":
      newState.resultsTaxAdd = action.value;
      newState.loading = false;
      break;
    case "TAX_RESPONSE_EDIT":
      newState.resultsTaxEdit = action.value;
      newState.loading = false;
      break;
    case "TAX_RESPONSE_DELETE":
      newState.resultsTaxDelete = action.value;
      newState.loading = false;
      break;
    case "TAX_PRODUCT_RESPONSE_ADD":
      newState.resultsTaxProductAdd = action.value;
      newState.loading = false;
      break;
    case "TAX_PRODUCTS_RESPONSE_GET":
      newState.resultsTaxProducts = action.value;
      newState.loading = false;
      break;
    case "TAX_PRODUCT_RESPONSE_DELETE":
      newState.resultsTaxProductsDelete = action.value;
      newState.loading = false;
      break;
    case "TAX_RESPONSE_UPDATE":
      newState.resultsTaxUpdate = action.value;
      newState.loading = false;
      break;
    case "TAXES_PRODUCT_RESPONSE_ADD":
      newState.resultsTaxesProductAdd = action.value;
      newState.loading = false;
      break;
    case "TAXES_PRODUCT_RESPONSE_DELETE":
      newState.resultsTaxesProductDelete = action.value;
      newState.loading = false;
      break;

    // Synchronous actions
    case "TAX_RESPONSE_RESET":
      newState.resultsTax = {};
      break;
    case "RESET_TAX_RESPONSES":
      newState.resultsTax = {};
      newState.resultsTaxAdd = {};
      newState.resultsTaxEdit = {};
      newState.resultsTaxUpdate = {};
      newState.resultsTaxDelete = {};
      newState.resultsTaxProductAdd = {};
      newState.resultsTaxProductsDelete = {};
      newState.resultsTaxesProductAdd = {};
      newState.resultsTaxesProductDelete = {};
      newState.resultsProductTaxesList = [];
      break;
    default:
      break;
  }
  return newState;
};

export default reducer;
